export class ServiceRequestRow {
    customsProcedureDate = null;
}
